import type { KAPLAYOpt } from 'kaplay'
import type { KAPLAYCtx } from './types.ts'
import kaplay from 'kaplay'
import loadFontAssets from './assets/fonts.ts'
import { useFloor08Scene } from './scenes/floor-08.ts'
import { useFloor09Scene } from './scenes/floor-09.ts'
import { useFloor10Scene } from './scenes/floor-10.ts'
import { useFloor11Scene } from './scenes/floor-11.ts'
import { useFloor12Scene } from './scenes/floor-12.ts'
import { useFloor13Scene } from './scenes/floor-13.ts'
import { useRotateScreenScene } from './scenes/rotate-screen.ts'
import { useStartScene } from './scenes/start.ts'

const gameCanvas = document.querySelector('canvas#game') as HTMLCanvasElement

const config: KAPLAYOpt = {
  canvas: gameCanvas,
  backgroundAudio: true,
  debug: !import.meta.env.PROD,
  debugKey: '\\',
  global: false,
  // tagsAsComponents: false,
  // maxFPS: 60,
  // width: 960,
  // height: 540,
  // letterbox: true,
  // pixelDensity: window.devicePixelRatio,
  // narrowPhaseCollisionAlgorithm: 'box',
  // broadPhaseCollisionAlgorithm: 'grid',
  // hashGridSize: 16,
  touchToMouse: true,
  background: '#B2D5F1',
  scale: 2,
  focus: true,
  crisp: true,
  buttons: {
    up: {
      keyboard: ['w', 'up'],
    },
    down: {
      keyboard: ['s', 'down'],
    },
    left: {
      keyboard: ['a', 'left'],
    },
    right: {
      keyboard: ['d', 'right'],
    },
    musicToggle: {
      keyboard: ['m'],
    },
    // fullscreenToggle: {
    //   keyboard: ['f'],
    // },
  },
}

const k = kaplay(config) as KAPLAYCtx

// Enable debug
if (!import.meta.env.PROD) k.debug.inspect = true

k.store = {
  currentScene: 'start', //'start',
  isPortrait: k.height() > k.width(),
  currLang: 'en',
  isMusicPlaying: true,
}

k.setLayers(['background', 'objects', 'hover', 'player_controls', 'ui', 'flash'], 'flash')

k.onResize(() => {
  k.store.isPortrait = k.height() > k.width()
  if (k.store.isPortrait) k.go('rotateScreen')
  else k.go(k.store.currentScene)
})

loadFontAssets(k)

// SCENES
useRotateScreenScene(k)
useStartScene(k)
useFloor08Scene(k)
useFloor09Scene(k)
useFloor10Scene(k)
useFloor11Scene(k)
useFloor12Scene(k)
useFloor13Scene(k)

// Go to the firs scene
if (k.store.isPortrait) k.go('rotateScreen')
else k.go(k.store.currentScene)
